import {Button} from 'react-bootstrap'
import {LinkContainer} from 'react-router-bootstrap'

const getFileIcon = files => {
    if(!files || files.length === 0) return 'far fa-file-alt'
    if(files.some(file => file.mimetype && file.mimetype.includes('video'))) return 'far fa-file-video'
    if(files.some(file => file.mimetype && file.mimetype.includes('pdf'))) return 'far fa-file-pdf'
    return 'far fa-file-image'
}

const DocumentCard = ({info}) => {
    const filesCount = info.files ? info.files.length : 0

    return (
        <article className='documents__card'>
            <div className='documents__icon'>
                <i className={getFileIcon(info.files)}></i>
            </div>
            <div className='documents__info'>
                <h3>{info.title}</h3>
                <p>{info.description}</p>
                <span>{filesCount > 0 ? `${filesCount} مرفق` : 'بدون مرفقات'}</span>
                <LinkContainer to={`/documents/${info._id}`}>
                    <Button variant='outline-light'>عرض الوثيقة</Button>
                </LinkContainer>
            </div>
        </article>
    )
}

export default DocumentCard
